import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ConfigProvider } from "./context/ConfigContext";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Today from "./pages/Today";
import Onboarding from "./pages/Onboarding";
import Create from "./pages/Create";
import MediaLibrary from "./pages/MediaLibrary";
import Leads from "./pages/Leads";
import WeeklyPlan from "./pages/WeeklyPlan";
import CalendarPage from "./pages/CalendarPage";
import CopyLibrary from "./pages/CopyLibrary";
import ContentLibrary from "./pages/ContentLibrary";
import ActivityHistory from "./pages/ActivityHistory";
import Settings from "./pages/Settings";
import Account from "./pages/Account";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center text-[#94A3B8] font-mono2 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Shell() {
  return (
    <Protected>
      <ConfigProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Today />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/create" element={<Create />} />
            <Route path="/media" element={<MediaLibrary />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/weekly" element={<WeeklyPlan />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/copy" element={<CopyLibrary />} />
            <Route path="/content" element={<ContentLibrary />} />
            <Route path="/history" element={<ActivityHistory />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/account" element={<Account />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </ConfigProvider>
    </Protected>
  );
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/*" element={<Shell />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
